module.exports = __webpack_public_path__ + "static/media/original(2).20fe1482.webp";